// extracted by mini-css-extract-plugin
module.exports = {"sideNav":"sidenav_sideNav__1pZfw","sideNavLink":"sidenav_sideNavLink__3VTlP","sideNavActive":"sidenav_sideNavActive__3rUzF"};